// src/App.js
import React, { useContext, useMemo } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

import { UIProvider } from "./context/UIContext";
import { AuthProvider } from "./context/AuthContext";
import { SettingsProvider, SettingsContext } from "./context/SettingsContext";
import { ModalProvider } from "./context/ModalContext";
import { ChatProvider } from "./context/ChatContext";

import { lightTheme, darkTheme } from "./theme";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Login from "./components/Login";
import Signup from "./components/Signup";
import MealPlanner from "./components/MealPlanner";
import ProtectedRoute from "./components/ProtectedRoute";
import SavedRecipes from "./components/SavedRecipes";
import CheckEmail from "./components/CheckEmail";
import ConfirmEmail from "./components/ConfirmEmail";
import ResetPasswordPage from "./components/ResetPasswordPage";
import SharedRecipes from "./components/SharedRecipes";
import TermsOfUse from "./components/TermsOfUse";

import "./App.css";

function App() {
  return (
    <UIProvider>
      <AuthProvider>
        <SettingsProvider>
          <MainApp />
        </SettingsProvider>
      </AuthProvider>
    </UIProvider>
  );
}

function MainApp() {
  const { darkMode } = useContext(SettingsContext);

  const theme = useMemo(() => (darkMode ? darkTheme : lightTheme), [darkMode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ModalProvider>
        <ChatProvider>
          <Router>
            <Navbar />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/check-email" element={<CheckEmail />} />
              <Route path="/confirm-email" element={<ConfirmEmail />} />
              <Route path="/meal-planner" element={<MealPlanner />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route
                path="/shared/recipe/:shareId"
                element={<SharedRecipes />}
              />
              <Route path="/terms" element={<TermsOfUse />} />
              <Route
                path="/saved-recipes"
                element={
                  <ProtectedRoute>
                    <SavedRecipes />
                  </ProtectedRoute>
                }
              />
              <Route path="/" element={<MealPlanner />} />
            </Routes>
            <Footer />
          </Router>
        </ChatProvider>
      </ModalProvider>
    </ThemeProvider>
  );
}

export default App;
